import React from 'react'
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import { DesktopSubmenu } from './desktop-submenu'

type DesktopFileMenuProps = {
  onClose?: () => void
  openPreferencesDialog: () => void
}

export const DesktopFileMenu: React.FC<DesktopFileMenuProps> = ({
  onClose,
  openPreferencesDialog,
}) => {
  return (
    <DesktopSubmenu label="File" alignOffset={-5}>
      <DropdownMenuItem>
        Generate Restore Version
        <ShortcutKbd shortcutKey="generateRestoreVersion" />
      </DropdownMenuItem>
      <DropdownMenuItem onSelect={() => onClose?.()}>Close</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem>Save Custom Template</DropdownMenuItem>
      <DropdownMenuItem>Make PDF</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem>Review Restore Versions</DropdownMenuItem>
      <DropdownMenuItem>Revert to Blank Spread</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault()
          openPreferencesDialog()
        }}
      >
        Preferences
      </DropdownMenuItem>
    </DesktopSubmenu>
  )
}
